import type { FileOwnerType, Watermark, WatermarkPosition } from 'types';

interface State extends Watermark {
  position: {
    block: [Extract<WatermarkPosition, 'top' | 'bottom'>, number | undefined];
    inline: [Extract<WatermarkPosition, 'right' | 'left'>, number | undefined];
  };
  ownerType: FileOwnerType;
}
const initialState: Partial<State> = {};

type Action =
  | {
      type: 'UPDATE_WATERMARK_IMAGE';
      payload: Pick<typeof initialState, 'imageId'>;
    }
  | {
      type: 'UPDATE_WATERMARK_WIDTH';
      payload: Pick<typeof initialState, 'minWidth' | 'width' | 'maxWidth'>;
    }
  | {
      type: 'UPDATE_WATERMARK_HEIGHT';
      payload: Pick<typeof initialState, 'minHeight' | 'height' | 'maxHeight'>;
    }
  | {
      type: 'UPDATE_WATERMARK_POSITION';
      payload: Pick<
        typeof initialState,
        'top' | 'right' | 'bottom' | 'left' | 'position'
      >;
    }
  | {
      type: 'UPDATE_WATERMARK_OPACITY';
      payload: Pick<typeof initialState, 'opacity'>;
    }
  | undefined;
const initialAction: Action = undefined;

export { initialAction, initialState };
